import React from 'react';
import styled from 'styled-components';
import Layout from '@p14/layouts';
import {compose} from 'recompose';
import * as Modules from './_';
import * as HOC from '@p14/HOC';
import * as Components from '@p14/components';
import data from '@p14/texts/lifestyle';

export const meta = {
  title: '«Пироговская, 14» — ваша личная Москва: консьерж сервис, библиотека, личный сад, камины, тренажерный зал.',
  keywords: 'Пироговская, 14,  Хамовники, жить, квартиры, недвижимость,',
  description: 'Дом почти невидим с улицы и повернут к пироговской самой узкой стороной. Здесь ваша личная Москва: с небольшим частным садом, каминами и библиотекой. Занимайтесь спортом в собственном зале, гуляйте по паркам и набережной Новодевичьего монастыря.',
};

export const Lifestyle = ({data, tr}) => (
  <Layout {...meta}>
    <Modules.Slider slides={data.allStrapiLifestyleslides.edges.map(({node}) => node)}/>
    <Modules.InnerSections/>
    {/* <Modules.FullScreenImage/> */}
    <Modules.OuterSections/>
    <Components.Blockquote
      quote={tr('quote')}
      captions={tr('quoteCaptions')}
      />
  </Layout>
);

export const enhance = compose(
  HOC.withTranslation(data),
);

export default enhance(Lifestyle);
